import Core from "./Core"
import List from "./List"
import Campaign from "./Campaign"
import Category from "./Category"
import Offer from "./Offer"

const Store = {
  namespaced: true,
  modules: {
    Core,
    List,
    Campaign,
    Category,
    Offer
  }
}

export default Store
